import { render, staticRenderFns } from "./voteList.vue?vue&type=template&id=def70198"
import script from "./voteList.vue?vue&type=script&lang=js"
export * from "./voteList.vue?vue&type=script&lang=js"
import style0 from "./voteList.vue?vue&type=style&index=0&id=def70198&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports